import styled, { css } from 'styled-components';
import { Step } from './Step';
import { colors, media } from 'tsx/theme';

const Div = styled.div`
  margin-bottom: 160px;
  .steps {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(10px, 1fr));
    align-items: center;
    justify-content: space-between;
  }

  ${media.lg(css`
    .steps {
      grid-gap: 10px;
    }
  `)};
  ${media.md(css`
    margin-bottom: 80px;
    .steps {
      grid-gap: 7px;
    }
  `)};
  ${media.sm(css`
    margin-bottom: 40px;
  `)};
`;

const Dash = styled.div<{ $isActive: boolean }>`
  height: 1px;
  background-color: ${({ $isActive }) => ($isActive ? colors.primary : colors.lp3)};
`;

interface StepperProps {
  step: number;
  isSingleAccount: boolean;
}

export const Stepper: React.FC<StepperProps> = ({ step, isSingleAccount }) => {
  const declarationStep = isSingleAccount ? 3 : 4;
  const upiStep = isSingleAccount ? 4 : 5;
  const summaryStep = isSingleAccount ? 5 : 6;
  return (
    <Div>
      <div className="steps">
        <Step step={1} isActive={step >= 1} text="Apply Online" />
        <Dash $isActive={step >= 1} />
        <Step step={2} isActive={step >= 2} text="Personal Details (Account Holder)" />
        <Dash $isActive={step >= 2} />
        {!isSingleAccount && (
          <>
            <Step step={3} isActive={step >= 3} text="Personal Details (2nd Account Holder)" />
            <Dash $isActive={step >= 3} />
          </>
        )}
        <Step step={declarationStep} isActive={step >= declarationStep} text="Declaration" />
        <Dash $isActive={step >= declarationStep} />
        <Step step={upiStep} isActive={step >= upiStep} text="Use of your Personal Information" />
        <Dash $isActive={step >= upiStep} />
        <Step step={summaryStep} isActive={step >= summaryStep} text="Summary" />
      </div>
    </Div>
  );
};
